import { Typography as FoodsTypography } from "@foodpilot/foods";
import { Typography as MuiTypography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils/formatting";
import EmptySetIcon from "src/assets/icons/empty-set.svg?react";
import { NumericalScoreValue } from "src/api/client-api/olapScores/olapScoresSchema";
import type { ComponentAppearance } from "src/components/appearance";

type Props = {
    value: NumericalScoreValue | undefined;
    precision: number;
    unit: string;
    appearance?: ComponentAppearance;
};
export const GridScoreDisplay = (props: Props) => {
    const { i18n } = useTranslation();
    const theme = useTheme();
    const isProductUxV2 = props.appearance === "product-v2";
    const Typography = isProductUxV2 ? FoodsTypography : MuiTypography;

    const { value, precision, unit } = props;

    if (value === null || value === undefined) {
        return <EmptySetIcon width="20px" title={"No score"} />;
    }

    const _scoreStr = formatNumber(
        value,
        i18n.resolvedLanguage,
        precision !== undefined ? { maximumFractionDigits: precision, minimumFractionDigits: precision } : {},
    );
    const scoreStr = _scoreStr.replace(/ /g, "\u00a0");

    const title = `${scoreStr} ${unit || ""}`;
    return (
        <Typography
            component="p"
            title={title}
            sx={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                whiteSpace: "initial",
                lineHeight: "normal",
                // textOverflow: "ellipsis",
                minWidth: 0, // Ensure the component can shrink
            }}
        >
            <Typography variant="number-small" component="span" sx={{ marginRight: theme.spacing(0.5) }}>
                {scoreStr}
            </Typography>
            <Typography variant="body" component="span" sx={{ color: "text.secondary" }}>
                {unit}
            </Typography>
        </Typography>
    );
};
